export default __webpack_public_path__ + "static/SofiaProRegular-353096e94d42a29fc7d28dd470bce145.woff";